import { render, staticRenderFns } from "./CreateLeadFooter.vue?vue&type=template&id=7b311b7e&"
import script from "./CreateLeadFooter.vue?vue&type=script&lang=ts&"
export * from "./CreateLeadFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports